import React from 'react';
import { VenueMap } from '../components/VenueMap';
import { SearchBar } from '../components/SearchBar';
import { useVenueStore } from '../store/useVenueStore';
import { VenueList } from '../components/VenueList';
import { AIAssistantCard } from '../components/AIAssistantCard';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/Header';

export const KartaPage: React.FC = () => {
  const { t } = useTranslation();
  const { venues } = useVenueStore();
  const setShowAIAssistant = useVenueStore(state => state.setShowAIAssistant);
  
  const handleOpenAIAssistant = () => {
    console.log("Opening AI Assistant");
    if (typeof setShowAIAssistant === 'function') {
      setShowAIAssistant(true);
    } else {
      console.error("setShowAIAssistant is not available, using URL fallback");
      window.location.href = '/ai-assistant';
    }
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {/* Fixed header - no TopBanner here anymore */}
      <Header 
        onMenuClick={() => {}} 
        onAboutClick={() => {}} 
        onContactClick={() => {}}
      />
      
      {/* Main content area that fills remaining space */}
      <main className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 flex flex-col md:flex-row overflow-hidden">
          {/* Sidebar - scrollable */}
          <div className="w-full md:w-[480px] bg-white shadow-lg z-10 flex flex-col">
            <div className="p-4 border-b flex-shrink-0">
              <AIAssistantCard onOpenAssistant={handleOpenAIAssistant} />
              <SearchBar />
            </div>
            <div className="flex-1 overflow-y-auto">
              <VenueList />
            </div>
          </div>

          {/* Map fills entire right side */}
          <div className="hidden md:block flex-1 h-full">
            <VenueMap />
          </div>
        </div>
      </main>
    </div>
  );
}; 